import React from 'react';
import './external-resource-slide.scss';

interface ExternalResourceSlideProps {
    title: string;
    url: string;
    imageSrc?: string;
}

export const ExternalResourceSlide = ({ title, url, imageSrc }: ExternalResourceSlideProps) => {
    const clickHandle = (url?: string) => {
        if (url) {
            window.open(url, '_blank', 'noopener, noopener');
        }
    };

    return (
        <div
            className="external-resource-slide"
            onClick={() => clickHandle(url)}
        >
            <img src={imageSrc} />
            <div className="title">{title}</div>
        </div>
    );
};
